import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { BOOKING_URL, IMG, NAV_ITEMS, scrollToId } from "../content";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 48);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => (e) => {
    e.preventDefault();
    setOpen(false);
    scrollToId(id);
  };

  return (
    <>
      <header className={`nav ${scrolled ? "nav-solid" : ""}`} data-testid="site-navigation">
        <a href="#top" className="brand" onClick={go("top")} data-testid="brand-link" aria-label="Mindful Athlete — back to top">
          <img src={IMG.logo} alt="Mindful Athlete" className="brand-logo" />
        </a>
        <nav className="nav-links" aria-label="Primary">
          {NAV_ITEMS.map(([label, id]) => (
            <a key={id} href={`#${id}`} onClick={go(id)} data-testid={`nav-${id}-link`}>
              {label}
            </a>
          ))}
          <a
            className="nav-cta"
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-booking-cta"
          >
            Book a session <ArrowUpRight size={14} />
          </a>
        </nav>
        <button
          type="button"
          className="menu-btn"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          data-testid="mobile-menu-button"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </header>
      <AnimatePresence>
        {open && (
          <motion.div
            className="mobile-menu"
            initial={{ opacity: 0, y: -12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            data-testid="mobile-menu"
          >
            {NAV_ITEMS.map(([label, id], i) => (
              <motion.a
                key={id}
                href={`#${id}`}
                onClick={go(id)}
                data-testid={`mobile-nav-${id}-link`}
                initial={{ opacity: 0, y: 14 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.08 + i * 0.06, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
              >
                {label}
              </motion.a>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;
